// extracted by mini-css-extract-plugin
module.exports = {"modeTab":"ModeSwitch_modeTab__afYIV","active":"ModeSwitch_active__sZYQW"};